export default "__VITE_ASSET__Dur_Kj5s__"